import Aos from "aos";
import React, { useEffect } from "react";
import { FaBalanceScale, FaGavel, FaFileContract, FaLock, FaShieldAlt, FaUserTie, FaHandshake, FaEuroSign, FaMoneyBill } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ConditionsVente = () => {
    useEffect(() => {
        Aos.init({
            duration: 1000,
            once: true
        });
        
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header/>
            <div className="conditions-page">
               
                <section className="hero-section py-5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12 text-center" data-aos="fade-up">
                                <h1 className="fw-bold mb-4">
                                    Conditions Générales <span className="gradient-text">de Vente CINEF-EC©</span>
                                </h1>
                                <p className="lead mb-0">
                                    Conditions régissant nos prestations d'expertise comptable et nos relations contractuelles.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Main Content */}
                <section className="conditions-content py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card shadow-sm mb-5" data-aos="fade-up">
                                    <div className="card-body p-4 p-md-5">
                                        
                                        {/* Introduction avec informations société */}
                                        <div className="intro-section mb-5">
                                            <div className="company-info mb-4 p-4 bg-light rounded">
                                                <p className="mb-3 fw-bold">
                                                    Le site www.cinef-expertises.com® est la propriété exclusive de la Société CINEF-EXPERTISE COMPTABLE (CINEF-EC), Société par Actions Simplifiée au capital de 3 000 000 FCFA, inscrite au registre du Commerce et du crédit mobilier sous le numéro RB/COT/25 B 39515 et dont le siège social est situé à Cotonou, Ilot 1398 Ste Rita, Immeuble BOCOVE.
                                                </p>
                                                <p className="mb-3">
                                                    La SAS CINEF-EC est inscrite au Tableau de l'Ordre des Experts-comptables et Comptables Agréés du Bénin.
                                                </p>
                                                <p className="mb-3">
                                                    En souscrivant une offre du site www.cinef-expertises.com® vous contracterez ainsi directement avec la SAS CINEF-EC, propriétaire du site.
                                                </p>
                                                <p className="mb-0 fw-bold text-danger">
                                                    CINEF-EC se réserve la possibilité de modifier ou mettre à jour ses conditions générales à tout moment.
                                                </p>
                                            </div>
                                        </div>

                                        {/* 1. DOMAINE D'APPLICATION */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">1. DOMAINE D'APPLICATION</h2>
                                            <p data-aos="fade-up">
                                                Les présentes conditions sont applicables aux conventions portant sur les missions conclues entre le cabinet « CINEF-EC » dénommé l'expert-comptable et son client. Le client reconnaît qu'il contracte en qualité de professionnel et que la lettre de mission annexée constitue un contrat de prestations de services en rapport direct avec ses activités professionnelles.
                                            </p>
                                        </div>

                                        {/* 2. DEFINITION DE LA MISSION */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">2. DÉFINITION DE LA MISSION</h2>
                                            <p data-aos="fade-up">
                                                Les travaux incombant à l'expert-comptable sont détaillés dans la lettre de mission et ses annexes (le cas échéant) et sont strictement limités à son contenu.
                                            </p>
                                        </div>

                                        {/* 3. OBLIGATIONS DE L'EXPERT-COMPTABLE */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">3. OBLIGATIONS DE L'EXPERT-COMPTABLE</h2>
                                            <p data-aos="fade-up">
                                                L'expert-comptable effectue la mission qui lui est confiée conformément aux dispositions du « Code éthique des professionnels de la comptabilité de l'espace OHADA », du « Dispositif anti-blanchiment des capitaux et du Manuel d'Assurance Qualité » en vigueur dans l'espace OHADA et le cas échéant de la norme professionnelle de travail spécifique à la mission considérée. Il contracte, en raison de cette mission, une obligation de moyens.
                                            </p>
                                            <p data-aos="fade-up">
                                                L'expert-comptable peut se faire assister par les collaborateurs de son choix. Le nom du collaborateur principal chargé du dossier est indiqué au client.
                                            </p>
                                            <div className="obligations-expert bg-light p-4 rounded" data-aos="fade-up">
                                                <h5 className="fw-bold mb-3">L'expert-comptable est tenu :</h5>
                                                <ul>
                                                    <li className="mb-2">à une obligation au secret professionnel dans les conditions prévues à l'article 622 de la loi n°2018-16 du 28 décembre 2018 portant Code pénal ;</li>
                                                    <li className="mb-2">à une obligation de discrétion, distincte de l'obligation précédente, quant aux informations recueillies et à la diffusion des documents qu'il a établis. Ces derniers sont adressés au client, à l'exclusion de tout envoi à un tiers, sauf demande du client. Les documents établis par l'expert-comptable seront en conséquence adressés au client, à l'exclusion de tout envoi direct à un tiers (sauf instruction spécifique de la part du client et exception faite des transmissions aux administrations fiscales et sociales).</li>
                                                </ul>
                                            </div>
                                        </div>

                                        {/* 4. OBLIGATIONS DU CLIENT */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">4. OBLIGATIONS DU CLIENT</h2>
                                            <p data-aos="fade-up">
                                                Le client s'interdit tout acte de nature à porter atteinte à l'indépendance de l'expert-comptable ou de ses collaborateurs, notamment en s'abstenant de leur faire toutes offres d'exécuter des missions pour leur propre compte ou de devenir salarié du client.
                                            </p>
                                            
                                            <div className="client-obligations bg-light p-4 rounded" data-aos="fade-up">
                                                <h5 className="fw-bold mb-3">Le client s'engage :</h5>
                                                
                                                <div className="mb-4">
                                                    <p className="fw-bold mb-2">A fournir à l'expert-comptable, préalablement au commencement de la mission, les informations et documents d'identification requis en application des dispositions du dispositif anti-blanchiment.</p>
                                                    <p className="mb-2">Le contrat est conclu sous condition suspensive de l'obtention de ces informations et documents.</p>
                                                    <p className="mb-2">La mission ne pourra donc pas être mise en œuvre avant leur obtention. Il s'agit :</p>
                                                </div>

                                                <div className="mb-4">
                                                    <p className="fw-bold mb-2">Dans le cadre de l'obligation d'identification du client :</p>
                                                    <ul>
                                                        <li className="mb-2">si le client est une personne physique, obtention d'un document d'identité officiel en cours de validité comportant sa photographie ;</li>
                                                        <li className="mb-2">si le client est une personne morale, tout acte ou extrait de registre officiel datant de moins de trois mois constatant la dénomination, la forme juridique, l'adresse du siège social, l'identité des associés et dirigeants et la composition et la répartition du capital.</li>
                                                    </ul>
                                                </div>

                                                <div className="mb-4">
                                                    <p className="fw-bold mb-2">Dans le cadre de l'obligation d'identification du bénéficiaire effectif, s'il apparait qu'une personne physique remplit les conditions pour être qualifiée de bénéficiaire effectif :</p>
                                                    <ul>
                                                        <li className="mb-2">les éléments d'identification de cette personne.</li>
                                                    </ul>
                                                </div>

                                                <ul>
                                                    <li className="mb-2">A mettre à la disposition de l'expert-comptable, dans les délais convenus, l'ensemble des documents et informations nécessaires à l'exécution de la mission ;</li>
                                                    <li className="mb-2">(Le cas échéant) A réaliser les travaux lui incombant conformément aux dispositions prévues dans le tableau de répartition des obligations respectives ;</li>
                                                    <li className="mb-2">A respecter les procédures mises en place pour la réalisation de la mission et notamment le planning d'intervention de l'expert-comptable figurant dans la lettre de mission ;</li>
                                                    <li className="mb-2">A porter à la connaissance de l'expert-comptable les faits nouveaux ou exceptionnels et à lui signaler également les engagements susceptibles d'affecter les résultats ou la situation patrimoniale de l'entité ;</li>
                                                    <li className="mb-2">A confirmer par écrit, si l'expert-comptable le lui demande, que les documents, renseignements et explications fournis sont exhaustifs et reflètent fidèlement la situation patrimoniale de l'entité ;</li>
                                                    <li className="mb-2">A vérifier que les états et documents produits par l'expert-comptable sont conformes aux demandes exprimées et aux informations fournies par lui-même et à informer sans retard le professionnel de tout manquement ou erreur.</li>
                                                </ul>
                                            </div>

                                            <div className="additional-obligations mt-4" data-aos="fade-up">
                                                <p className="mb-3">
                                                    Le client reste responsable de la bonne application de la législation et des règlements en vigueur ; l'expert-comptable ne peut être considéré comme se substituant aux obligations du client du fait de cette mission.
                                                </p>
                                                <p className="mb-3">
                                                    Conformément aux prescriptions légales, le client doit prendre toutes les mesures nécessaires pour conserver les pièces justificatives et, d'une façon générale, l'ensemble des documents produits par l'expert-comptable pendant les délais de conservation requis par la loi ou le règlement.
                                                </p>
                                                <p className="mb-3">
                                                    Dès lors que des traitements sont assurés sur le système informatique du client, ce dernier devra assurer la sauvegarde et l'archivage des données et des traitements informatisés pour en garantir la conservation, l'inviolabilité et la lecture ultérieure.
                                                </p>
                                                <p className="mb-0">
                                                    D'une façon générale, le client doit par ailleurs prendre toutes les mesures nécessaires pour assurer la protection de son système informatique.
                                                </p>
                                            </div>
                                        </div>

                                        {/* 5. HONORAIRES */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">5. HONORAIRES</h2>
                                            <p data-aos="fade-up">
                                                L'expert-comptable reçoit du client des honoraires librement convenus qui sont exclusifs de toute autre rémunération, même indirecte. Il est remboursé de ses frais de déplacement et débours.
                                            </p>
                                            <p data-aos="fade-up">
                                                Des acomptes sur honoraires peuvent être demandés périodiquement.
                                            </p>
                                            
                                            <div className="payment-conditions bg-light p-4 rounded" data-aos="fade-up">
                                                <h5 className="fw-bold mb-3">Les conditions de règlement des honoraires sont les suivantes :</h5>
                                                <ul>
                                                    <li className="mb-3">Les honoraires sont payés à leur date d'échéance ; en cas de paiement anticipé, aucun escompte n'est accordé ; en cas de retard de paiement, des pénalités de retard sont exigibles le jour suivant la date de règlement figurant sur la facture ; sauf disposition contraire qui ne peut toutefois fixer un taux d'intérêt de ces pénalités inférieur à trois fois le taux d'intérêt légal, le taux d'intérêt sera égal à celui appliqué par la Banque Centrale des Etats de l'Afrique de l'Ouest à son opération de refinancement la plus récente majoré de 10 points de pourcentage.</li>
                                                    <li className="mb-3">Les pénalités de retard sont exigibles sans qu'un rappel soit nécessaire.</li>
                                                    <li className="mb-3">Une indemnité forfaitaire pour frais de recouvrement d'un montant de <strong>25 000 FCFA</strong> est également exigible de plein droit en cas de retard de paiement. Lorsque les frais de recouvrement exposés sont supérieurs au montant de cette indemnité forfaitaire, une indemnisation complémentaire peut être réclamée sur justificatifs.</li>
                                                    <li className="mb-3">Toute contestation d'une facture devra être faite dès réception, préciser la prestation contestée, et être motivée ; ladite contestation ne pourra justifier le non-paiement des autres prestations non contestées, y compris celles réalisées concomitamment, simultanément, ou lorsque les conditions de recours à la facture périodique sont remplies, incluses dans la même facture.</li>
                                                    <li className="mb-3">Le non-paiement des honoraires pourra, après rappel par lettre recommandée avec accusé de réception, entraîner la suspension des travaux ou mettre fin à la mission.</li>
                                                    <li className="mb-3">En cas de changement de modalités de facturation, une information préalable sera donnée au client.</li>
                                                    <li className="mb-3">En cas de rupture du contrat par l'une ou l'autre des parties, une assistance pour réaliser le transfert du dossier dans l'entreprise ou à un nouveau prestataire pourra être effectuée à la demande du client.</li>
                                                    <li className="mb-0">En cas d'usage du droit de rétention relatif à l'exercice de l'activité d'expertise comptable, le président de l'OECCA-BENIN sera informé.</li>
                                                </ul>
                                            </div>
                                        </div>

                                        {/* 6. RESPONSABILITE CIVILE PROFESSIONNELLE DE L'EXPERT-COMPTABLE */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">6. RESPONSABILITÉ CIVILE PROFESSIONNELLE DE L'EXPERT-COMPTABLE</h2>
                                            <p data-aos="fade-up">
                                                La responsabilité civile professionnelle de l'expert-comptable ne peut être mise en jeu que sur une période contractuellement définie à 1 an à compter du jour où le client a connu ou aurait dû connaître les faits lui permettant de la mettre en cause.
                                            </p>
                                            <p data-aos="fade-up">
                                                Tout événement susceptible d'avoir des conséquences notamment en matière de responsabilité doit être porté
                                            </p>
                                            
                                            <div className="responsibility-limit p-4 border-left-danger" data-aos="fade-up">
                                                <p className="mb-3">
                                                    La responsabilité contractuelle de l'expert-comptable à l'égard du client, pour toutes les conséquences dommageables d'une même mission, est limitée à un plafond de <strong className="text-danger">10 000 000 FCFA</strong> par sinistre et par assuré par année d'assurance.
                                                </p>
                                                <p className="mb-0">
                                                    La responsabilité civile professionnelle de l'expert-comptable est couverte par un contrat d'assurance.
                                                </p>
                                            </div>

                                            <div className="exclusions-responsabilite mt-4" data-aos="fade-up">
                                                <h5 className="fw-bold mb-3">La responsabilité de l'expert-comptable ne peut notamment être engagée dans l'hypothèse où le préjudice subi par le client est une conséquence :</h5>
                                                <ul>
                                                    <li className="mb-2">d'une information erronée ou d'une faute ou négligence commise par le client ou par ses salariés,</li>
                                                    <li className="mb-2">du retard ou de la carence du client à fournir une information nécessaire à l'expert-comptable,</li>
                                                    <li className="mb-0">des fautes commises par des tiers intervenant chez le client.</li>
                                                </ul>
                                            </div>
                                        </div>

                                        {/* 7. RESILIATION DE LA MISSION */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">7. RÉSILIATION DE LA MISSION</h2>
                                            <p data-aos="fade-up">
                                                En cas de résiliation par le client au cours d'un exercice comptable (ou pendant la mission en cas de mission ponctuelle), et sauf faute grave imputable à l'expert-comptable, le client devra verser à ce dernier les honoraires dus pour le travail déjà effectué, majorés d'une indemnité conventionnelle égale à <strong>25%</strong> des honoraires annuels convenus pour l'exercice en cours ou de la dernière année d'honoraires en cas de montant incertain.
                                            </p>
                                            <p data-aos="fade-up">
                                                En cas de manquement du client à l'une de ses obligations, l'expert-comptable aura la faculté de mettre fin à sa mission après l'envoi d'une mise en demeure sous forme de lettre recommandée restée sans effet.
                                            </p>
                                            <p data-aos="fade-up">
                                                Dès la survenance d'un évènement susceptible de le placer dans une situation de conflit d'intérêts ou de porter atteinte à son indépendance, l'expert-comptable a l'obligation de dénoncer le contrat.
                                            </p>
                                        </div>

                                        {/* 8. SUSPENSION DE LA MISSION */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">8. SUSPENSION DE LA MISSION</h2>
                                            <p data-aos="fade-up">
                                                Lorsque la mission est suspendue pour cause de force majeure (empêchement temporaire), les délais de remise des travaux sont prolongés pour une durée égale à celle de la suspension susvisée, à moins que le retard en résultant ne justifie la résolution.
                                            </p>
                                            <p data-aos="fade-up">
                                                Pendant la période de suspension, toutes les dispositions du contrat demeurent applicables.
                                            </p>
                                            <p data-aos="fade-up">
                                                En cas de manquement du client à l'une de ses obligations (exemple : défaut de paiement des honoraires à l'échéance prévue), l'expert-comptable aura la faculté de suspendre sa mission après l'envoi d'une mise en demeure sous forme de lettre recommandée restée sans effet, et ne pourra être tenu responsable des conséquences préjudiciables pouvant découler de cette suspension.
                                            </p>
                                        </div>

                                        {/* 9. GESTION DES DONNEES A CARACTERE PERSONNEL */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">9. GESTION DES DONNÉES À CARACTÈRE PERSONNEL</h2>
                                            <p data-aos="fade-up">
                                                Chaque partie garantit que les traitements des données personnelles dont elle est responsable sont effectués conformément aux dispositions de la loi n° N° 2009-09 du 22 mai 2009 relative à la protection des données à caractère personnel en République du Bénin
                                            </p>
                                            <p data-aos="fade-up">
                                                Le traitement et le transfert de données à caractère personnel par le cabinet auront pour finalités l'exécution et le suivi de la mission, la relation client et la gestion informatique des données. Le client consent par la présente auxdits traitements et transferts, et peut exercer son droit d'accès, de rectification et d'opposition en adressant un courriel à l'adresse suivante <strong>direction@cinef-expertises.com</strong>
                                            </p>
                                        </div>

                                        {/* 10. DIFFERENDS */}
                                        <div className="section mb-5">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">10. DIFFÉRENDS</h2>
                                            <p data-aos="fade-up">
                                                En cas de contestation par le client des conditions d'exercice de la mission ou de différend sur les honoraires, l'expert-comptable s'efforce de faire accepter la conciliation ou l'arbitrage du président de l'ordre avant toute action en justice.
                                            </p>
                                        </div>

                                        {/* 11. DROIT APPLICABLE ET ATTRIBUTION DE COMPETENCES */}
                                        <div className="section">
                                            <h2 className="fw-bold mb-4" data-aos="fade-right">11. DROIT APPLICABLE ET ATTRIBUTION DE COMPÉTENCES</h2>
                                            <p data-aos="fade-up">
                                                Ce contrat de mission sera régi et interprété selon le droit béninois.
                                            </p>
                                            <div className="jurisdiction-notice p-4 bg-warning-light rounded fw-bold text-center" data-aos="fade-up">
                                                <p className="mb-0">
                                                    « TOUS LES LITIGES AUXQUELS LE CONTRAT POURRA DONNER LIEU, NOTAMMENT AU SUJET DE SA VALIDITÉ, DE SON INTERPRÉTATION, DE SON EXÉCUTION ET DE SA RÉALISATION, SERONT SOUMIS AUX TRIBUNAUX COMPÉTENTS DE COTONOU »
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Legal Icons */}
                                <div className="row legal-icons mb-5">
                                    <div className="col-md-3 text-center mb-4" data-aos="fade-up">
                                        <FaUserTie className="legal-icon mb-3" />
                                        <h5 className="fw-bold">Expertise Professionnelle</h5>
                                        <p>Services conformes aux standards OHADA et aux normes professionnelles.</p>
                                    </div>
                                    <div className="col-md-3 text-center mb-4" data-aos="fade-up" data-aos-delay="100">
                                        <FaHandshake className="legal-icon mb-3" />
                                        <h5 className="fw-bold">Engagement Contractuel</h5>
                                        <p>Relations client basées sur la confiance et la transparence.</p>
                                    </div>
                                    <div className="col-md-3 text-center mb-4" data-aos="fade-up" data-aos-delay="200">
                                        <FaShieldAlt className="legal-icon mb-3" />
                                        <h5 className="fw-bold">Assurance Professionnelle</h5>
                                        <p>Responsabilité civile couverte par une assurance professionnelle.</p>
                                    </div>
                                    <div className="col-md-3 text-center mb-4" data-aos="fade-up" data-aos-delay="300">
                                        <FaEuroSign className="legal-icon mb-3" />
                                        <h5 className="fw-bold">Honoraires Transparents</h5>
                                        <p>Tarification claire et conditions de paiement définies.</p>
                                    </div>
                                </div>

                                {/* Contact Section */}
                                <div className="contact-box text-center p-4 rounded" data-aos="zoom-in">
                                    <h3 className="fw-bold mb-3">Questions sur nos conditions de vente ?</h3>
                                    <p className="mb-4">Notre équipe est disponible pour clarifier tous les aspects contractuels de nos prestations.</p>
                                    <a href="mailto:direction@cinef-expertises.com" className="cta-button">Contactez-nous ↗</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <style>{`
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    
                    body {
                        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                        line-height: 1.6;
                    }
                    
                    .container {
                        max-width: 1200px;
                        margin: 0 auto;
                        padding: 0 15px;
                    }
                    
                    .row {
                        display: flex;
                        flex-wrap: wrap;
                        margin: 0 -15px;
                    }
                    
                    .col-lg-12, .col-md-3, .col-md-4 {
                        padding: 0 15px;
                    }
                    
                    .col-lg-12 { width: 100%; }
                    .col-md-4 { width: 33.333%; }
                    .col-md-3 { width: 25%; }
                    
                    @media (max-width: 768px) {
                        .col-md-3, .col-md-4 { width: 100%; }
                    }

                    .hero-section {
                        background: linear-gradient(rgba(42, 119, 255, 0.05), rgba(230, 57, 70, 0.05));
                        padding: 80px 0;
                    }

                    .gradient-text {
                        background: linear-gradient(to right, #008a44, #dc3545);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                    }

                    .conditions-content {
                        background-color: #f8f9fa;
                    }

                    .card {
                        border: none;
                        border-radius: 15px;
                        background: white;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    }

                    h1 {
                        font-size: 2.5rem;
                        margin-bottom: 1rem;
                    }

                    h2 {
                        color: #008a44;
                        border-left: 4px solid #e63946;
                        padding-left: 15px;
                        font-size: 1.5rem;
                        margin-bottom: 1rem;
                    }

                    h3 {
                        font-size: 1.25rem;
                        margin-bottom: 1rem;
                    }

                    h5 {
                        font-size: 1.1rem;
                        margin-bottom: 0.5rem;
                    }

                    .lead {
                        font-size: 1.25rem;
                        font-weight: 300;
                    }

                    .fw-bold {
                        font-weight: 700;
                    }

                    .text-center {
                        text-align: center;
                    }

                    .text-danger {
                        color: #dc3545;
                    }

                    .mb-0 { margin-bottom: 0; }
                    .mb-2 { margin-bottom: 0.5rem; }
                    .mb-3 { margin-bottom: 1rem; }
                    .mb-4 { margin-bottom: 1.5rem; }
                    .mb-5 { margin-bottom: 3rem; }
                    .mt-4 { margin-top: 1.5rem; }

                    .py-5 { padding: 3rem 0; }
                    .p-4 { padding: 1.5rem; }
                    .p-md-5 { padding: 3rem; }

                    
                    .company-info {
                        background-color: #f8f9fa;
                        border-radius: 8px;
                        box-shadow: 0 1px 6px rgba(0,0,0,0.05);
                    }

                    .obligations-expert,
                    .client-obligations,
                    .payment-conditions,
                    .responsibility-limit {
                        background-color: #fff;
                        border-radius: 8px;
                        box-shadow: 0 1px 6px rgba(0,0,0,0.04);
                    }

                    .border-left-danger {
                        border-left: 4px solid #dc3545;
                        background: #fff8f8;
                    }

                    .legal-icon {
                        font-size: 2.5rem;
                        color: #008a44;
                    }

                    .cta-button {
                        display: inline-block;
                        background: linear-gradient(90deg, #008a44 0%, #e63946 100%);
                        color: #fff;
                        padding: 0.75rem 2rem;
                        border-radius: 30px;
                        font-weight: 700;
                        text-decoration: none;
                        transition: background 0.3s;
                    }

                    .cta-button:hover {
                        background: linear-gradient(90deg, #e63946 0%, #008a44 100%);
                        color: #fff;
                    }

                    .bg-light {
                        background-color: #f8f9fa !important;
                    }

                    .bg-warning-light {
                        background-color: #fff3cd !important;
                    }

                    .rounded {
                        border-radius: 8px !important;
                    }

                    .shadow-md {
                        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                    }
                `}</style>
            </div>

            <Footer/>
        </>
    );
};

export default ConditionsVente;
